import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DataTable from './DataTable';
import { useTranslation } from 'react-i18next';

const LeaveHistoryPage = () => {
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t("Balance's History")}</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item href="/table-leave">{t('Leave')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('History')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default LeaveHistoryPage; 